import { Alert, List } from 'antd';
import { memo, useEffect, useState } from 'react';

import { Bid } from 'models/bid/Bid';

import { fetchBids } from 'apis/bid';
import UserAvatar from 'pages/users/Profile/components/UserAvatar';
import { formatCurrency } from 'utils';
import { unixTimestampMsToLocaleString } from 'utils/date';

import styles from './BidsList.module.css';
import useAppSelector from 'hooks/useAppSelector';

interface BidsListProps {
  auctionId: string | undefined;
  bidCount: number;
}

function BidsList({ auctionId, bidCount }: BidsListProps) {
  const { loginUser } = useAppSelector((state) => state.user);

  const [bids, setBids] = useState<Bid[] | undefined>(undefined);
  const [errMsg, setErrMsg] = useState<string>('');

  useEffect(() => {
    if (bidCount && auctionId) {
      fetchBids(auctionId)
        .then((bids) => setBids(bids.map((bid) => ({ ...bid, key: bid.id }))))
        .catch((errMsg) => setErrMsg(errMsg));
    }
  }, [auctionId, bidCount]);

  return (
    <div>
      {bidCount !== 0 ? (
        <List
          className={styles.list}
          loading={!bids}
          pagination={{ pageSize: 10, showSizeChanger: false }}
          dataSource={bids}
          renderItem={({ id, censored_email, disclosed_price, bids_at, is_mine }) => (
            // TODO: bids 응답에 해당 사용자 id가 주어지게 되면, link를 걸어 프로필 페이지로 이동하게 하기
            <List.Item key={id} className={`${styles.item} ${is_mine ? styles.mine : ''}`}>
              <List.Item.Meta
                avatar={<UserAvatar email={is_mine ? loginUser?.email ?? '' : censored_email} size={40} />}
                title={formatCurrency(disclosed_price)}
                description={unixTimestampMsToLocaleString(bids_at)}
              />
            </List.Item>
          )}
        />
      ) : (
        <Alert message="입찰 내역이 없습니다" description="첫 번째 입찰자가 되어주세요!" type="info" showIcon />
      )}
      {errMsg && <Alert message={errMsg} type="error" showIcon />}
    </div>
  );
}

export default memo(BidsList);
